// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__V6oZP","question":"styles_question__2C1c7","inputVisibleButton":"styles_inputVisibleButton__6nDjJ","note":"styles_note__nSvlc"};